import { styled, Breakpoints } from '@vw-marketing/us-components';

interface StyledBackgroundProps {
  readonly backgroundColor: string;
}

export const StyledBackground: any = styled.div<StyledBackgroundProps>`
  background: ${props => props.backgroundColor || '#ccab0d'};
  position: relative;
  display: flex;
  flex-flow: wrap;

  > div:nth-child(1) {
    position: absolute;
  }

  > div:nth-child(2) {
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    > div:nth-child(1) {
      position: static;
    }

    > div:nth-child(2) {
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

interface StyledTextWrapperProps {
  readonly headTextColor: string;
}

export const StyledTextWrapper: any = styled.div<StyledTextWrapperProps>`
  color: ${props => props.headTextColor || '#000'};
  padding: 10px 10px 0;
`;

export const StyledImagePlaceholder: any = styled.div`
  padding-top: 13%;
  margin-bottom: -17%;
`;

export const StyledImageWrapper: any = styled.div`
  position: relative;

  > img:nth-child(2) {
    transform: scale(1.15);
    margin-top: -20px;
    margin-bottom: 10px;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    > img:nth-child(2) {
      margin-bottom: 10px;
    }
  }

  @media (min-width: ${Breakpoints.b960}px) {
    > img:nth-child(2) {
      margin-bottom: 0;
    }
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    > img:nth-child(2) {
      margin-bottom: 10px;
    }
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    > img:nth-child(2) {
      margin-bottom: 25px;
    }
  }
`;

export const StyledImageGroup: any = styled.div`
  width: 100%;
`;

export const ModelCardContainer: any = styled.div`
  padding-top: 20px;
  display: flex;
  flex-flow: wrap;
  width: 100%;
  margin-bottom: 30px;
  @media (min-width: ${Breakpoints.b560}px) {
    margin-bottom: 0;
  }
`;

export const OverallRatingTextWrapper: any = styled.div`
  width: 100%;
  padding-top: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${Breakpoints.b560}px) {
    padding-top: 110px;
  }
  @media (min-width: ${Breakpoints.b960}px) {
    margin-bottom: 0;
    padding-top: 55px;
  }
`;

export const FiveStarsWrapper: any = styled.div`
  width: 100%;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
`;

export const FiveStarsTextWrapper: any = styled.div`
  padding-left: 5px;
  color: #758189;
  white-space: nowrap;
`;
export const FiveStarsDisclaimerWrapper: any = styled.div`
  padding: 30px 20px;
`;
